export const bookWithMeShareLinkByEmailSubject = "NliQF";
export const bookWithMeShareLinkByEmailBody = "rgvQgb";
export const bookWithMeEmailSentSuccessfullyNotification = "X13s5d";
export const bookWithMeEmailNotificationFailed = "lBsI5d";
export const bookWithMeLinkDisplayName = "GsTaYb";
export default {bookWithMeShareLinkByEmailSubject,bookWithMeShareLinkByEmailBody,bookWithMeEmailSentSuccessfullyNotification,bookWithMeEmailNotificationFailed,bookWithMeLinkDisplayName};